// src/modules/expert/events/routes.ts
import type { RouteRecordRaw } from 'vue-router'

export const eventsRoutes: RouteRecordRaw[] = [
  {
    path: ':id/events',
    name: 'events-list',
    component: () => import('@/modules/expert/events/views/List.vue'),
  },
  {
    path: ':id/events/new',
    name: 'create-event',
    component: () => import('@/modules/expert/events/views/EventForm.vue'),
  },
  {
    path: ':id/events/:eventId/edit',
    name: 'edit-event',
    component: () => import('@/modules/expert/events/views/EventForm.vue'),
    props: true,
  },
  {
    path: ':id/events/:eventId/detail',
    name: 'event-detail',
    component: () => import('@/modules/expert/events/views/Detail.vue'),
    props: true,
  },
  {
    path: ':id/events/:eventId/list-participant',
    name: 'event-list-participant',
    component: () =>
      import('@/modules/expert/events/views/ParticipantType.vue'),
    props: true,
  },
  {
    path: ':id/events/:eventId/new-participant-form',
    name: 'new-form-participant',
    component: () =>
      import('@/modules/expert/events/views/ParticipantForm.vue'),
    props: true,
  },
  {
    path: ':id/events/:eventId/edit-participant-form/:typeId',
    name: 'edit-form-participant',
    component: () =>
      import('@/modules/expert/events/views/ParticipantForm.vue'),
    props: true,
  },
  {
    path: ':id/events/:eventId/list-invites',
    name: 'event-list-invites',
    component: () => import('@/modules/expert/events/views/InvitesList.vue'),
    props: true,
  },
  {
    path: ':id/events/:eventId/participant-management',
    name: 'participant-management',
    component: () =>
      import('@/modules/expert/events/views/ParticipantManagement.vue'),
    props: true,
  },

  // ✅ Rota nova (expert) usando inviteKey (padrão atual)
  {
    path: 'accept-form/:inviteKey',
    name: 'event-accept-form', // nome único pra não colidir com a rota guest
    component: () =>
      import('@/modules/guest/registration/views/FormInvite.vue'),
    props: (route) => ({
      inviteKey: String(route.params.inviteKey || ''),
    }),
    meta: { requiresAuth: true },
  },

  // ♻️ Rota legada (se já existem links com :inviteId)
  {
    path: 'accept-form/:inviteId',
    name: 'event-accept-form-legacy',
    component: () =>
      import('@/modules/guest/registration/views/FormInvite.vue'),
    props: (route) => ({
      inviteKey: String(route.params.inviteId || ''),
    }),
    meta: { requiresAuth: true },
  },

  {
    path: ':id/events/:eventId/registrations/:registrationId',
    name: 'registration-detail',
    component: () =>
      import('@/modules/expert/events/views/RegistrationDetail.vue'),
    props: true,
  },
]
